module.exports = require("github:jspm/nodelibs-http@1.7.1/index.js");